import api from "./api";

export async function getNewsletters(params) {
  const res = await api.get("/admin/newsletters", { params });
  return res.data.data;
}

export async function sendNewsletter(payload) {
    const res = await api.post("/admin/newsletters/send", payload);
}